import { useState, useEffect } from 'react';

interface ScreenSize {
  width: number;
  height: number;
  isNarrow: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isLandscape: boolean;
  shouldShowFallback: boolean;
}

export const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>({
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768,
    isNarrow: false,
    isMobile: false,
    isTablet: false,
    isLandscape: false,
    shouldShowFallback: false,
  });

  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isNarrow = width < 600; // Very narrow screens
      const isMobile = width < 768; // Mobile phones
      const isTablet = width >= 768 && width < 1024; // Tablets and mid-sized screens
      const isLandscape = width > height;
      const shouldShowFallback = (isNarrow && !isLandscape) || width < 450; // Force fallback for very narrow screens

      setScreenSize({
        width,
        height,
        isNarrow,
        isMobile,
        isTablet,
        isLandscape,
        shouldShowFallback,
      });
    };

    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);
    window.addEventListener('orientationchange', updateScreenSize);

    return () => {
      window.removeEventListener('resize', updateScreenSize);
      window.removeEventListener('orientationchange', updateScreenSize);
    };
  }, []);

  return screenSize;
};
